import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PauseStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M8.5 5C8.5 4.86193 8.38807 4.75 8.25 4.75H5.25C5.11193 4.75 5 4.86193 5 5V19C5 19.1381 5.11192 19.25 5.25 19.25H8.25C8.38808 19.25 8.5 19.1381 8.5 19V5ZM10 19C10 19.9665 9.21648 20.75 8.25 20.75H5.25C4.28352 20.75 3.5 19.9665 3.5 19V5C3.5 4.03351 4.28351 3.25 5.25 3.25H8.25C9.21649 3.25 10 4.03351 10 5V19Z"
				fill="currentColor"
			/>
			<path
				d="M19 5C19 4.86192 18.8881 4.75 18.75 4.75H15.75C15.6119 4.75 15.5 4.86192 15.5 5V19C15.5 19.1381 15.6119 19.25 15.75 19.25H18.75C18.8881 19.25 19 19.1381 19 19V5ZM20.5 19C20.5 19.9665 19.7165 20.75 18.75 20.75H15.75C14.7835 20.75 14 19.9665 14 19V5C14 4.03352 14.7835 3.25 15.75 3.25H18.75C19.7165 3.25 20.5 4.03352 20.5 5V19Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PauseStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PauseStrokeIcon;
